import React from "react";
import ProgressSvg from "../../../assets/svgicons/progress-bar/progress_bar_3_2.svg";

const Progress_3_2 = (props) => {
  return <img src={ProgressSvg} alt="Progress 3-2" {...props} />;
};

export default Progress_3_2;
